// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap___FDLA","right":"styles_right__Fl3Ci"};